import script from "./ViewRolesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRolesPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewRolesPage.vue?vue&type=style&index=0&id=26c62a41&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c62a41"]])

export default __exports__